import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=14a36070&scoped=true"
import script from "./RolePermissions.vue?vue&type=script&lang=js"
export * from "./RolePermissions.vue?vue&type=script&lang=js"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=14a36070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a36070",
  null
  
)

export default component.exports